import { Color, rwd, Spacing, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'

export const OverlayContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: scroll;
`
export const OverlaySubscriptionPlansAndHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  padding: ${Spacing.S40};
`

export const OverlayHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${Spacing.S40};
`

export const OverlayHeaderLeftSection = styled.div``

export const CampaignOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${zIndex.FullScreenOverlay};
  background-color: ${Color.Grey100};
  overflow: auto;

  ${rwd.greaterThan('xlarge')} {
    left: 232px;
  }
`
